













































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import moment from 'moment';

@Component
export default class DateField extends Vue {
  @Prop(String) public label;
  @Prop(String) public readonly field!: string;
  @Prop(Object) public readonly rec!: object;
  @Prop() public readonly rules!: any;
  @Prop({ type: Boolean, default: false }) public readonly isReadOnly!: boolean;
  @Prop({ type: Boolean, default: false }) public readonly clearable!: boolean;

  public dateFormatted = this.formatDate(this.rec[this.field]);
  public menu1 = false;
  public menu2 = false;

  public formatDate(value) {
    if (value) {
      return moment.utc(value).local().format('DD-MM-YYYY');
    } else {
      return null;
    }
  }

  public parseDate(value) {
    if (value) {
      return moment.utc(value, 'DD-MM-YYYY').local().format('YYYY-MM-DD');
    } else {
      return null;
    }
  }

  public changed(event) {
    this.$emit('enter', event);
    this.$emit('input', event);
    this.menu1 = false;
    this.dateFormatted = this.formatDate(this.rec[this.field]);
  }

  @Watch('rec') public dateChanged(value: string, oldValue: string) {
    this.dateFormatted = this.formatDate(this.rec[this.field]);
  }
}
